/* global */

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'tabbed_card_handler';
export let global_vars = {};

// Local imports
import {
    postGiftToCart,
    updateAddButtonStatus,
} from '../../util/postTabbedGift.js';

// Add click listeners to the add buttons in the tabbed gift cards
function init_tabbed_cards_listeners(global) {
    let all_tabbed = global.document.querySelectorAll(
        'div.card--tabbedproduct'
    );

    for (let card of all_tabbed) {
        let cardnum = card.dataset.cardnum;
        let button_id = `buttonid${cardnum}`;
        let button = global.document.querySelector(`#${button_id}`);
        if (!button) {
            continue;
        }
        updateAddButtonStatus(global, cardnum);

        button.addEventListener('click', event => {
            if (!button.classList.contains('button--disabled')) {
                event.preventDefault();
                on_tabbed_card_add_clicked(global, cardnum);
            }
        });

        init_tabbed_cards_select_listener(global, cardnum);
    }
}

function on_tabbed_card_add_clicked(global, cardnum) {
    let form = global.document.getElementById(`form${cardnum}`);
    postGiftToCart(global, form, cardnum);
}

function init_tabbed_cards_select_listener(global, cardnum) {
    let variantSelect = global.document.getElementById(`variantid${cardnum}`);
    if (!variantSelect) {
        return;
    }
    variantSelect.addEventListener('change', () => {
        updateAddButtonStatus(global, cardnum);
    });
}

export function initialize(global) {
    init_tabbed_cards_listeners(global);
}
